import { SUBSCRIPTION_TYPES } from "@/utils/shopify";
import ProductType from "./ProductType";
import Ingredient from "./Ingredient";

export default class CMSProduct {
  title: string;
  displayTitle: string;
  productType: ProductType;
  reviewCategory: string;
  images: string[];
  imagesAlt: string[];
  lifestyleImages: string[];
  shortDescription: string;
  longDescription: string;
  badge: string;
  topBadge: string;
  productLine: string;
  productVideo: string;
  carouselVideo: string;
  displayImgIndex: number;
  hoverImgIndex: number;
  ingredientsList?: string[];
  petWarning: boolean;
  variantCarousel: any;
  priceText?: string;
  variantSalesPriceText?: any;
  bottomBanner?: string;
  bottomBannerMobile?: string;
  hereUntilText?: string;
  startDate?: string;
  rating: number;
  endDate?: string;
  preselectedVariant?: string;
  productReviews?: object[];

  constructor(cmsProduct?: any) {
    this.title = cmsProduct.title;
    this.displayTitle = cmsProduct.display_name;
    this.productType = new ProductType(cmsProduct.product_type);
    this.reviewCategory = cmsProduct.review_category;
    this.images = [];
    this.imagesAlt = [];
    this.lifestyleImages = [];
    this.shortDescription = cmsProduct.short_description;
    this.longDescription = cmsProduct.long_description;
    this.rating = cmsProduct.rating;
    this.badge = cmsProduct.badge;
    this.topBadge = cmsProduct.top_badge;
    this.productLine = cmsProduct.product_line;
    this.productVideo = cmsProduct.product_video;
    this.carouselVideo = cmsProduct.carousel_video;
    this.displayImgIndex = cmsProduct.display_img_index;
    this.hoverImgIndex = cmsProduct.hover_img_index;
    this.ingredientsList = cmsProduct.ingredients_list?.map(
      (ingredient: any) => {
        return new Ingredient(ingredient);
      }
    );
    this.petWarning = cmsProduct.pet_warning;
    this.variantCarousel = cmsProduct.variant_carousel;
    this.bottomBanner = cmsProduct.product_bottom_banner;
    this.bottomBannerMobile = cmsProduct.product_bottom_banner_mobile;
    this.hereUntilText = cmsProduct.hereuntiltext;
    this.startDate = cmsProduct.start_date;
    this.endDate = cmsProduct.end_date;
    this.preselectedVariant = cmsProduct.preselected_variant;
    this.productReviews = cmsProduct.product_reviews;

    for (const key of [
      "img1",
      "img2",
      "img3",
      "img4",
      "img5",
      "img6",
      "img7"
    ]) {
      if (cmsProduct?.[key]) {
        this.images.push(cmsProduct?.[key]);
        this.imagesAlt.push(
          cmsProduct?.[`image_alt_` + key.replace("img", "")]
        );
      }
    }

    for (const key of [
      "img1_lifestyle",
      "img2_lifestyle",
      "img3_lifestyle",
      "img4_lifestyle",
      "img5_lifestyle"
    ]) {
      if (cmsProduct?.[key]) {
        this.lifestyleImages.push(cmsProduct?.[key]);
      }
    }

    if (SUBSCRIPTION_TYPES.includes(this.productType.key)) {
      this.priceText = cmsProduct.price_text;
      this.variantSalesPriceText = [];

      for (const key of [
        "basic_per_bouquet",
        "signature_standard_per_bouquet",
        "signature_deluxe_per_bouquet",
        "signature_grand_per_bouquet",
        "luxe_per_bouquet"
      ]) {
        if (cmsProduct?.[key]) {
          const objectWithKey = new Object() as any;
          objectWithKey[key] = cmsProduct?.[key];
          this.variantSalesPriceText.push(objectWithKey);
        }
      }
    }
  }
}
